
import { useDropzone } from "react-dropzone";
import { useFileUpload } from "@/hooks/useFileUpload";
import { DropZone } from "./upload/DropZone";
import { UploadProgress } from "./upload/UploadProgress";
import { UploadForm } from "./upload/UploadForm";

export default function FileUpload() {
  const {
    files,
    uploading,
    progress,
    uploadedFiles,
    customName,
    uploadComplete,
    currentTotalSize,
    removeFile,
    handleDrop,
    copyToClipboard,
    handleUpload,
    resetUpload,
    handleCustomNameChange
  } = useFileUpload();

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    multiple: true,
    noClick: false,
    noKeyboard: false,
  });

  const renderContent = () => {
    if (uploading || uploadComplete) {
      return (
        <UploadProgress
          progress={progress}
          currentTotalSize={currentTotalSize}
          uploadComplete={uploadComplete}
          onCopyLink={copyToClipboard}
          onReset={resetUpload}
          filePath={uploadedFiles[0]?.filename}
          transferId={uploadedFiles[0]?.id}
        />
      );
    }

    return (
      <div className="w-full max-w-md mx-auto">
        <DropZone
          onDrop={handleDrop}
          isDragActive={isDragActive}
          getInputProps={getInputProps}
          getRootProps={getRootProps}
        />
        {files.length > 0 && (
          <UploadForm
            files={files}
            customName={customName}
            onCustomNameChange={handleCustomNameChange}
            onRemoveFile={removeFile}
            onUpload={handleUpload}
          />
        )}
      </div>
    );
  };

  return (
    <div className="flex flex-col items-center w-full">
      {renderContent()}
    </div>
  );
}
